import { Button, type ButtonProps, Tooltip } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'
import { formatCurrency } from 'core/utils/currency'

import { getBidButtonText } from '../../../presenters/bidPresenter'

type BidButtonProps = {
  displayCountdown: boolean
  displayTooltip: boolean
  isMobile?: boolean
  price?: number
  disabled: boolean
  countdown?: number
  onClick: () => void
}

export function BidButton({
  displayCountdown,
  displayTooltip,
  isMobile,
  price,
  disabled,
  countdown,
  onClick,
}: BidButtonProps) {
  const haveActiveBid = Boolean(price)
  const displayLeading = displayCountdown || haveActiveBid
  let buttonProps: ButtonProps = {
    type: 'button',
    onClick,
    variant: 'secondary',
    disabled,
  }

  const buttonText = getBidButtonText(displayCountdown, haveActiveBid, isMobile, countdown, price)

  if (haveActiveBid && !isMobile) {
    buttonProps = { ...buttonProps, trailing: formatCurrency(price) }
  }

  if (displayLeading && !isMobile) {
    buttonProps = { ...buttonProps, leading: <Icon name="clock" /> }
  }

  return displayTooltip ? (
    <Tooltip
      trigger="hover"
      placement="top-start"
      message="We now provide instant feedback for bids! Bid on a load to check it out!"
    >
      <Button {...buttonProps}>{buttonText}</Button>
    </Tooltip>
  ) : (
    <Button {...buttonProps}>{buttonText}</Button>
  )
}
